module.exports = __webpack_public_path__ + "img/ring_r_o_null_1.340d8a97.png";